import { ExpandableResource } from '@shared/components/tree-data-table/expandable-resource';

export const makeNewFolderFactory = () => {
  return new ExpandableResource(
    { name: '', description: '', isDir: true, data: [] },
    { childKey: 'data', hasChildrenIndicator: 'isDir' }
  );
};

export const makeTransientFolder = () => {
  const tracientFolder: any = makeNewFolderFactory();
  tracientFolder.name = 'NONE';
  tracientFolder.id = -1;
  return tracientFolder;
};
